import { createContext } from 'react';
// secretCode was dropped from this shape — VerifyTOTP's response no longer
// carries one (see useToken.js's storeToken for why), so nothing ever set
// it to anything but null.
export const AuthContext = createContext({
    token: null,
    role: null,
    storeToken: () => { },
    setPreference: () => { },
    getPreference: () => { },
    removeToken: () => { },
    updateCompany: () => { },
});